import { ProjectDeliverablesScreen_TableFragment } from "../../../fragments.generated";

export function mapTableToTextForClipboard(table: ProjectDeliverablesScreen_TableFragment): string {
    const columns = table.columns.map(x => x.title).join("\t");
    const records = table.rows.map(row => row.columns.map(x => x.value).join("\t")).join("\n");
    return [columns, records].join("\n");
}
